import type { ExtendedBid } from '@/features/bidding/types/bid'

export const getLatestExtendedBid = (bids: ExtendedBid[]): ExtendedBid =>
  bids.toSorted((a, b) => b.createdAt.valueOf() - a.createdAt.valueOf())[0]
